export default __webpack_public_path__ + "media/images/christmas-trees-fun-card-title-5115475abbd07f6e452cef2023d262df.svg";